















import { Component, Vue, Prop } from "vue-property-decorator";
import { CollectionEventDetailsModel } from "@/api/CollectionEvents";
import FormattedAddress from "@/components/Address/FormattedAddress.vue";

@Component({ components: { FormattedAddress } })
export default class CollectionEventDetailsHeader extends Vue {
  @Prop(Object) readonly details?: CollectionEventDetailsModel;
  @Prop(Boolean) readonly isCollectionIssue?: boolean;
}
